import React from 'react'
import _ from 'lodash'
import { Button } from 'react-bootstrap'
import origMoment from 'moment'
import { extendMoment } from 'moment-range'
const moment = extendMoment(origMoment)

export default class QuickSelection extends React.Component {
  constructor(props) {
    super(props)
    this.isCurrentlySelected = this.isCurrentlySelected.bind(this)
    this.getBsStyle = this.getBsStyle.bind(this)
    this.onSelect = this.onSelect.bind(this)
  }

  state = {
    lastDays: '',
    daysAgoStart: '',
    daysAgoEnd: '',
  }

  isCurrentlySelected(dateRange) {
    const { value } = this.props
    if (!value) { return false }
    return (
      (value.start.format('YYYY MM DD') === dateRange.start.format('YYYY MM DD'))
      && (value.end.format('YYYY MM DD') === dateRange.end.format('YYYY MM DD'))
    )
  }

  getBsStyle(dateRange) {
    return this.isCurrentlySelected(dateRange) ? '#0d6efd' : '#F5F5F5'
  }
  
  onSelect(e) {
    this.props.onSelect(this.props.quickDateRanges[e.target.getAttribute('label')])
  }

  onSelectLastDays = () => {
    this.props.onSelect(moment.range(moment().subtract(this.state.lastDays, 'days'), moment()))
  }

  onSelectDaysAgo = () => {
    this.props.onSelect(moment.range(
      moment().subtract(this.state.daysAgoStart > this.state.daysAgoEnd ? this.state.daysAgoStart : this.state.daysAgoEnd, 'days'),
      moment().subtract(this.state.daysAgoEnd > this.state.daysAgoStart ? this.state.daysAgoStart : this.state.daysAgoEnd, 'days')
    ))
  }

  render() {
    const { quickDateRanges } = this.props

    return (
      <div
        className='quick-selection'
        style={{
          paddingLeft: 16,
          paddingRight: 16,
          width: '100%',
          display: 'flex',
          flexWrap: 'wrap',
        }}
      >
        {
          _.keys(quickDateRanges).map(label => {
            if (quickDateRanges[label].divider) {
              return
            }
            else {
              return (
                <div style={{width: '50%', display: 'flex', justifyContent: 'center', marginBottom: 8,}} key={label}>
                  <div
                    style={{
                      width: '80%',
                      backgroundColor: this.isCurrentlySelected(quickDateRanges[label]) ? '#0d6efd' : '#F5F5F5',
                      borderRadius: 4,
                      textAlign: 'center',
                      color: this.isCurrentlySelected(quickDateRanges[label]) ? 'white' : '#333',
                      cursor: 'pointer',
                    }}
                    onClick={this.onSelect}
                    label={label}
                  >{label}</div>
                </div>
              )
            }
          })
        }
      </div>
    )
  }
}
